import React, { useState } from "react";
import _ from 'i18n';
import { Col, Row, Icon } from "antd";
import EventProgressBar from "./EventProgressBar";
import { connect } from "react-redux";
import moment from 'moment';
import CycleDataTable from "./CycleDataTable";
import CycleDataTableRow from "./CycleDataTableRow";
import EventCharts from "./EventCharts";
import CongressDetails from "./Congress/CongressDetails";
import { fetchCycleTrainings } from "../../../actions/thunks/eventStats";

const EventDataTableRow = ({ event, eventStatsFilter, fetchCycleTrainings }) => {

  const [isActive, setIsActive] = useState(false);
  const [cycleIsActive, setCycleIsActive] = useState(false);
  const [cycleTrainings, setCycleTrainings] = useState([]);
  const [cycleTrainingsFetching, setCycleTrainingsFetching] = useState(true);
  const [cycleTrainingsError, setCycleTrainingsError] = useState(false);

  const handleChevronDownClick = () => {
    setIsActive(!isActive);
  };

  const handleCycleChevronDownClick = () => {
    setCycleIsActive(!cycleIsActive);

    if (cycleTrainings.length === 0) {
      fetchCycleTrainingsData();
    }
  };

  const fetchCycleTrainingsData = () => {
    setCycleTrainingsFetching(true);
    setCycleTrainingsError(false);

    fetchCycleTrainings(event.eventId, eventStatsFilter.year)
      .then((res) => {
        setCycleTrainingsFetching(false);
        setCycleTrainings(res.data.data);
      })
      .catch((err) => {
        setCycleTrainingsFetching(false);
        setCycleTrainingsError(true);
        setCycleTrainings([]);
      });
  };

  const { appType } = eventStatsFilter;
  const startTime = appType !== 'congres' ? moment(event.startDateTime) : moment(event.startDateTime, 'DD/MM/YYYY');
  const endTime = appType !== 'congres' ? moment(event.endDateTime) : moment(event.endDateTime, 'DD/MM/YYYY');
  const dateHelper = `${_('from_time')} ${startTime.format('HH:mm')} ${_('to_time')} ${endTime.format('HH:mm')}`;

  const registrants = event.paidRegistrant + event.notPaidRegistrant;

  const cyclePaidRegistrant = appType[0] === 'registering' ? event.stats.cyclePaidRegistrant : null;
  const cycleNotPaidRegistrant = appType[0] === 'registering' ? event.stats.cycleNotPaidRegistrant : null;

  const subscribers = appType[0] === 'registering' ? cyclePaidRegistrant + cycleNotPaidRegistrant : null;

  return (
    <div className={isActive ? "event-stats-row-container event-stats-row-container-active" : "event-stats-row-container"}>
      <Row className="event-stats-row" justify="space-around">
        <Col span={1}>
          <div
            className={'event-stats-activity-row-border ' +
              (appType === 'registering' ? 'blue' :
                (appType === 'cycle_registering' ? 'purple' :
                  (appType === 'all_in' ? 'orange' : 'grey')))}
          ></div>
        </Col>
        <Col span={3} className="event-stats-date">
          {appType === 'registering' ? (
            <div>
              {startTime.locale('fr').format('ll')} <br /> {dateHelper}
            </div>
          ) : (
            <div>
              {_('from_time') + ' ' + startTime.locale('fr').format('ll')} <br />
              {_('to_time') + ' ' + endTime.locale('fr').format('ll')}
            </div>
          )}
        </Col>
        <Col span={7}>
          <div className="event-stats-title mb-1">{event.eventName}</div>
          <div className="event-stats-speaker">
            {(appType === 'registering' || appType === 'congres')
              ? 1 + ' ' + _('registering')
              : event.nbrFormation + ' ' + _('registering') + 's'}
          </div>
        </Col>
        <Col offset={1} span={3}>
          <EventProgressBar
            progress={(event.paidRegistrant / registrants) * 100}
            number={event.paidRegistrant}
            cycleRegistrant={cyclePaidRegistrant}
          />
        </Col>
        <Col offset={1} span={3}>
          <EventProgressBar
            progress={(event.notPaidRegistrant / registrants) * 100}
            number={event.notPaidRegistrant}
            cycleRegistrant={cycleNotPaidRegistrant}
          />
        </Col>
        <Col offset={1} span={4}>
          <div className="event-stats-title event-stats-col-total">
            <div>
              {appType[0] === 'registering' ? registrants + subscribers : registrants} {' '}
              {appType[0] === 'registering'
                ? `(${subscribers} ${subscribers > 1 ? _("SUBSCRIBERS") : _("SUBSCRIBER")})`
                : (registrants > 1 ? _('REGISTRATIONS') : _('REGISTRATION'))}
            </div>

            <div className={'ml-auto'}>
              <img
                src="/img/icons/chevron-down.svg"
                onClick={handleChevronDownClick}
                className={isActive ? "event-stats-chevron-down event-stats-chevron-rotate" : "event-stats-chevron-down"}
              />
            </div>
          </div>
        </Col>
      </Row>
      {isActive && (
        <div>
          <img src="/img/icons/hr.svg" className="event-stats-hr" />
          <div className="event-stats-title event-stats-details">{_('DETAILS')}</div>
          {appType === 'congres' && (
            <div className={'congress-details-container'}>
              {event.plan && event.plan.length > 0 && (
                <CongressDetails type={"pass"} data={event.plan} />
              )}
              {event.pack && event.pack.length > 0 && (
                <CongressDetails type={"pack"} data={event.pack} />
              )}
            </div>
          )}

          <EventCharts event={event} />
          {(appType !== 'registering' && appType !== 'congres') && (
            <div>
              {cycleIsActive && (
                <div>
                  <img src="/img/icons/hr.svg" className="event-stats-hr" />
                  <div className={"event-stats-title ml-8 mt-3 mb-12"}>{_('CYCLE_TRAINING')}</div>
                  <CycleDataTable />
                  {cycleTrainingsFetching === true && (
                    <div className={'flex justify-center items-center'} style={{ height: "150px" }}>
                      <Icon type="sync" spin style={{ fontSize: "50px", color: "#29394D" }} />
                    </div>
                  )}
                  {cycleTrainings.map((x, i) => (
                    <CycleDataTableRow key={i} event={x} />
                  ))}
                  {cycleTrainingsError === true && (
                    <div className={'flex items-center flex-column justify-center my-4 retry-container'}>
                      <div className={'retry-label mb-3'}>{_('ERROR_OCCURED')}</div>
                      <button type={"button"} className={'retry-button'} onClick={fetchCycleTrainingsData}>
                        {_('RETRY')}
                      </button>
                    </div>
                  )}
                </div>
              )}
              <div className={'flex justify-center items-center mt-12 '}>
                <div className={"event-cycle-trainings"}>
                  {cycleIsActive ? _('REDUCE_CYCLE') : _('DISPLAY_TRAININGS')}
                </div>
              </div>
              <div className={'flex justify-center items-center'}>
                <div className={"event-cycle-chevron"} onClick={handleCycleChevronDownClick}>
                  <img
                    src="/img/icons/chevron-down.svg"
                    className={cycleIsActive && "cycle-stats-chevron-rotate"}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
});

const mapDispatchToProps = {
  fetchCycleTrainings,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventDataTableRow);


// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventDataTableRow.js